export default __webpack_public_path__ + "static/media/plans-modal-background.5689f476.png";